import { render, staticRenderFns } from "./PromotionBox.vue?vue&type=template&id=0f30cb12"
import script from "./PromotionBox.vue?vue&type=script&lang=ts"
export * from "./PromotionBox.vue?vue&type=script&lang=ts"
import style0 from "./PromotionBox.vue?vue&type=style&index=0&id=0f30cb12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports